import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Users } from "lucide-react";
import { fmtDataHora } from "@/pages/alertas/DigestConfigCard";

export default function DigestLastRunCard({ cfg }) {
  const sum = cfg.last_run_summary || {};
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <Users className="w-4 h-4" /> Último envio automático
        </CardTitle>
        <CardDescription>Resumo da última execução do job.</CardDescription>
      </CardHeader>
      <CardContent>
        {!cfg.last_run_at ? (
          <div className="text-sm text-slate-500 italic">Nenhum envio automático até agora.</div>
        ) : (
          <div className="grid md:grid-cols-4 gap-3 text-sm">
            <div>
              <div className="text-xs text-slate-500">Executado em</div>
              <div className="font-semibold">{fmtDataHora(cfg.last_run_at)}</div>
            </div>
            <div>
              <div className="text-xs text-slate-500">E-mails enviados</div>
              <Badge className="bg-emerald-100 text-emerald-800 border-emerald-300 mt-0.5">
                {sum.enviados ?? 0}
              </Badge>
            </div>
            <div>
              <div className="text-xs text-slate-500">Pulados (sem pend./opt-out)</div>
              <Badge className="bg-slate-100 text-slate-700 border-slate-300 mt-0.5">
                {sum.pulados ?? 0}
              </Badge>
            </div>
            <div>
              <div className="text-xs text-slate-500">Pendências agregadas</div>
              <div className="font-mono text-xs">
                Novas: {sum.total_novas ?? 0} ·
                Docs: {sum.total_pendentes ?? 0} ·
                OTPs: {sum.total_otps ?? 0}
              </div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
